module.exports = __webpack_public_path__ + "static/media/05B.c598c7eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/05B.png
// module id = 262
// module chunks = 0